import { useState } from "react";

export const SettingRow = ({ icon, title, desc, toggle, defaultOn }) => {
  const [on, setOn] = useState(defaultOn);
  return (
    <div className="bg-white rounded-2xl p-4 border border-gray-100 shadow-sm flex items-center gap-4">
      <span className="text-2xl">{icon}</span>
      <div className="flex-1">
        <p className="font-bold text-gray-900 text-sm">{title}</p>
        <p className="text-xs text-gray-400">{desc}</p>
      </div>
      {toggle && (
        <button onClick={() => setOn(!on)} className={`relative w-12 h-6 rounded-full transition-colors btn-press ${on?"bg-[#f97316]":"bg-gray-200"}`}>
          <div className={`absolute top-1 w-4 h-4 bg-white rounded-full shadow transition-all ${on?"right-1":"left-1"}`}/>
        </button>
      )}
    </div>
  );
};